import React, { FC, useState, useEffect, useContext } from 'react'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { notify } from 'react-notify-toast'

import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericInput from '../../../GenericComponents/GenericInput'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericIcon from '../../../GenericComponents/GenericIcon'

import AppContext from '../../../context/appContext'
import GenericButton from '../../../GenericComponents/GenericButton'
import { WizzardPageBox } from '../../AddUserScreen/style/UserWIzzardStyle'
import FrontOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_front_outline.png'
import SideOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_side_outline.png'
import BackOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_back_outline.png'

import { addUserFeed, generatePhotoAwsUrl } from '../../../Api/backendApi'

import WizzardPhotoMode from '../../AddUserScreen/views/WizzardPhotoMode'

interface NewEntryInterface {
  handleNewEntryData: Function
  handleProgressNewEntry: Function
  handleGoToMainPage: Function
  newEntryProgress: number
  newEntryDimensions: {
    belly_circumference: number
    thigh_circumference: number
    hip_circumference: number
  }
  setAddEntryMode: Function
}

const NewEntry: FC<NewEntryInterface> = ({
  handleNewEntryData,
  handleProgressNewEntry,
  newEntryProgress,
  newEntryDimensions,
  setAddEntryMode,
  handleGoToMainPage,
}) => {
  const appContext = useContext(AppContext)
  const [frontPhoto, setFrontPhoto] = useState({
    displayPhoto: '',
    filePhoto: null,
  })
  const [backPhoto, setBackPhoto] = useState({
    displayPhoto: '',
    filePhoto: null,
  })
  const [sidePhoto, setSidePhoto] = useState({
    displayPhoto: '',
    filePhoto: null,
  })
  const [photoOrder, setPhotoOrder] = useState(0)

  const handleNextPhoto = () => {
    switch (photoOrder) {
      case 0:
        frontPhoto.filePhoto == null
          ? notify.show(`Proszę wybrać zdjęcie z przodu`, 'error', 3000)
          : setPhotoOrder(photoOrder + 1)
        break
      case 1:
        sidePhoto.filePhoto == null
          ? notify.show(`Proszę wybrać zdjęcie z boku`, 'error', 3000)
          : setPhotoOrder(photoOrder + 1)
        break
      case 2:
        backPhoto.filePhoto == null
          ? notify.show(`Proszę wybrać zdjęcie od tyłu`, 'error', 3000)
          : setPhotoOrder(photoOrder + 1)
        break
      default:
        break
    }
  }

  const handleImageUpload = (e: any, photoOrder: number) => {
    if (e.target.files[0]) {
      switch (photoOrder) {
        case 0:
          setFrontPhoto({
            displayPhoto: URL.createObjectURL(e.target.files[0]),
            filePhoto: e.target.files[0],
          })
          break
        case 1:
          setSidePhoto({
            displayPhoto: URL.createObjectURL(e.target.files[0]),
            filePhoto: e.target.files[0],
          })
          break
        case 2:
          setBackPhoto({
            displayPhoto: URL.createObjectURL(e.target.files[0]),
            filePhoto: e.target.files[0],
          })
          break
      }
    }
  }

  const storeDataInBackend = async () => {
    if (newEntryProgress == 2) {
      if (
        newEntryDimensions.thigh_circumference == 0 ||
        newEntryDimensions.thigh_circumference > 300 ||
        newEntryDimensions.thigh_circumference < 20
      ) {
        notify.show(`Musisz uzupełnić obwód ud`, 'error', 3000)
        return
      }
    }
    const date = new Date()
    const formattedDate = moment(date).format('YYYY-MM-DD')
    let result = new Array(3)

    await addUserFeed(
      newEntryDimensions.belly_circumference,
      newEntryDimensions.hip_circumference,
      newEntryDimensions.thigh_circumference,
      formattedDate
    )

    if (newEntryProgress != 2) {
      result[0] = await generatePhotoAwsUrl('F', frontPhoto.filePhoto)
      result[1] = await generatePhotoAwsUrl('S', sidePhoto.filePhoto)
      result[2] = await generatePhotoAwsUrl('B', backPhoto.filePhoto)

      Promise.all([result[0], result[1], result[2]]).then(() => {
        setTimeout(() => {
          handleGoToMainPage(true)
          setAddEntryMode(false)
        }, 500)
      })
    } else {
      setTimeout(() => {
        handleGoToMainPage(true)
        setAddEntryMode(false)
      }, 500)
    }
  }

  const changeUploadImageButtonText = () => {
    let text = ''

    switch (photoOrder) {
      case 0:
        frontPhoto.filePhoto == null
          ? (text = 'Wybierz zdjęcie')
          : (text = 'Zmień zdjęcie')
        break
      case 1:
        sidePhoto.filePhoto == null
          ? (text = 'Wybierz zdjęcie')
          : (text = 'Zmień zdjęcie')
        break
      case 2:
        backPhoto.filePhoto == null
          ? (text = 'Wybierz zdjęcie')
          : (text = 'Zmień zdjęcie')
        break
      default:
        break
    }

    return text
  }

  const handleBackgroundSize = () => {
    let photoBackgroundSize = null

    switch (photoOrder) {
      case 0:
        frontPhoto.displayPhoto
          ? (photoBackgroundSize = '78%')
          : (photoBackgroundSize = '45%')
        break
      case 1:
        sidePhoto && sidePhoto.displayPhoto
          ? (photoBackgroundSize = 'contain')
          : (photoBackgroundSize = '26%')
        break
      case 2:
        backPhoto && backPhoto.displayPhoto
          ? (photoBackgroundSize = 'contain')
          : (photoBackgroundSize = '46%')
        break
      default:
        break
    }

    return photoBackgroundSize
  }

  const handlePhotoBackground = () => {
    let photoBackground = null

    switch (photoOrder) {
      case 0:
        frontPhoto.displayPhoto
          ? (photoBackground = frontPhoto.displayPhoto)
          : (photoBackground = FrontOutline)
        break
      case 1:
        sidePhoto && sidePhoto.displayPhoto
          ? (photoBackground = sidePhoto.displayPhoto)
          : (photoBackground = SideOutline)
        break
      case 2:
        backPhoto && backPhoto.displayPhoto
          ? (photoBackground = backPhoto.displayPhoto)
          : (photoBackground = BackOutline)
        break
      default:
        break
    }

    return photoBackground
  }

  const handleNextButtonAction = () => {
    switch (newEntryProgress) {
      case 3:
        if (frontPhoto.filePhoto && photoOrder == 0) {
          setPhotoOrder(1)
        } else if (
          frontPhoto.filePhoto &&
          sidePhoto.filePhoto &&
          photoOrder == 1
        ) {
          setPhotoOrder(2)
        } else if (
          frontPhoto.filePhoto &&
          sidePhoto.filePhoto &&
          backPhoto.filePhoto &&
          photoOrder == 2
        )
          storeDataInBackend()
        break
      default:
        break
    }
  }

  const handleNextButtonText = () => {
    let text = ''
    switch (newEntryProgress) {
      case 3:
        if (frontPhoto.filePhoto) {
          text = 'Dodaj zdjęcie'
        }
        if (sidePhoto.filePhoto) {
          text = 'Dodaj zdjęcie'
        }
        if (backPhoto.filePhoto) {
          text = 'Dodaj wpis'
        }

        break

      default:
        break
    }
    return text
  }

  return (
    <>
      <GenericMainCard
        flexDir={'column'}
        width={isMobile ? '95%' : '50%'}
        className="standard"
        margin={'4% auto 0 auto'}
        // height={newEntryProgress < 3 ? 'unset' : '85vh'}
      >
        <GenericRow>
          <GenericTextSpan fSize={'1.8rem'}>Nowy wpis</GenericTextSpan>
        </GenericRow>

        <GenericRow margin={'4% 0 0 0'}>
          <GenericTextSpan fSize={'1.1rem'}>
            {moment().format('Do MMMM YYYY')}
          </GenericTextSpan>
        </GenericRow>

        {newEntryProgress < 3 ? (
          <>
            <GenericRow margin={'4% 0 0 0'}>
              <GenericTextSpan fSize={'2.2rem'}>
                {newEntryProgress == 0 &&
                  'Zmierz obwód brzucha na wysokości pępka'}
                {newEntryProgress == 1 &&
                  'Zmierz obwód bioder w najszerszym ich miejscu'}
                {newEntryProgress == 2 && 'Zmierz obwód uda'}
              </GenericTextSpan>
            </GenericRow>

            <GenericInput
              onChange={(e: any) =>
                handleNewEntryData(
                  newEntryProgress == 0
                    ? 'belly'
                    : newEntryProgress == 1
                    ? 'hip'
                    : 'thigh',
                  e.target.value
                )
              }
              tAlign={'center'}
              fSize={'2.5rem'}
              width={'60%'}
              value={
                newEntryProgress == 0
                  ? newEntryDimensions.belly_circumference
                  : newEntryProgress == 1
                  ? newEntryDimensions.hip_circumference
                  : newEntryDimensions.thigh_circumference
              }
              autoFocus
              placeholder={'Podaj wartość w cm'}
              className={'no-border color-white font-big-always dimension'}
              margin={'5% 0 0 0'}
              type="number"
            />

            <GenericTextSpan width={'50%'} margin={'4% 0 0 0'} fSize={'1.1rem'}>
              Te informacje widzisz TYLKO Ty i nikt nie ma do nich dostępu
            </GenericTextSpan>

            <GenericButton
              onClick={
                photoOrder == 2 ? storeDataInBackend : handleProgressNewEntry
              }
              margin={'4% 0 0 0'}
              width={isMobile ? '90%' : '40%'}
              justify={'center'}
              className={'with-arrow standard'}
            >
              {photoOrder == 2 ? 'Dodaj wpis' : 'Przejdź dalej'}
            </GenericButton>

            {newEntryProgress == 2 && (
              <GenericTextSpan
                onClick={storeDataInBackend}
                className={'link'}
                fSize={isMobile ? '1rem' : '1.2rem'}
                position={'relative'}
                margin={'3% 0 0 2%'}
              >
                Dodaj wpis bez zdjęć
              </GenericTextSpan>
            )}
          </>
        ) : (
          <WizzardPhotoMode
            photoOrder={photoOrder}
            frontPhoto={frontPhoto}
            sidePhoto={sidePhoto}
            backPhoto={backPhoto}
            handleImageUpload={handleImageUpload}
            handleNextButtonAction={handleNextButtonAction}
            handleNextButtonText={handleNextButtonText}
            isEntryMode={true}
          />
          // <>
          //   <WizzardPageBox className="wizzard-photo-upload">
          //     <GenericIcon
          //       src={handlePhotoBackground()}
          //       width={isMobile ? '60%' : '30%'}
          //       height={isMobile ? '50vh' : '35vh'}
          //       backgroundSize={handleBackgroundSize()}
          //     ></GenericIcon>

          //     <label className="custom-file-upload">
          //       <input
          //         accept="image/*"
          //         type="file"
          //         onChange={(e: any) => handleImageUpload(e, photoOrder)}
          //       />
          //       {changeUploadImageButtonText()}
          //     </label>
          //   </WizzardPageBox>
          //   <GenericButton
          //     onClick={
          //       photoOrder == 2 && backPhoto.filePhoto
          //         ? () => storeDataInBackend()
          //         : () => handleNextPhoto()
          //     }
          //     margin={'4% 0 0 0'}
          //     width={isMobile ? '90%' : '40%'}
          //     justify={'center'}
          //     className={'with-arrow standard'}
          //   >
          //     {photoOrder < 2 ? 'Przejdź dalej' : 'Dodaj wpis'}
          //   </GenericButton>
          // </>
        )}
      </GenericMainCard>
      {!isMobile && newEntryProgress < 3 && (
        <GenericRow margin={newEntryProgress >= 3 ? '1% 0 0 0' : '5% 0 0 0'}>
          <GenericLogo
            theme={appContext.appState.theme == 'light' ? 'light' : null}
          />
        </GenericRow>
      )}
    </>
  )
}

export default NewEntry
